<template>
  <div class="info-dialog common-dialog">
    <div class="info-main">
      <div class="dialog-content">
        <p class="title"> {{ episode.title }}</p>
        <p class="text time">{{ episode.publishTime }}</p>
        <div class="text description" v-html="episode.content" />
      </div>
      <button class="close" @click="close">
        <icon-close></icon-close>
      </button>
    </div>
  </div>
</template>

<script>
import IconClose from "./icons/IconClose";
import {mapGetters, mapState} from "vuex";
import {MUTATION_UPDATE} from "@/store/mutations";

export default {
  name: "InfoDialog",
  components: {IconClose },
  mounted() {

  },
  computed: {
    ...mapGetters(["episode"]),
    ...mapState(["setting"]),
  },
  methods: {
    close() {
      this.$store.commit(MUTATION_UPDATE, ["isNonAppDownloadDialogOpen", false]);
      this.$emit('hide');
    },
  },
};
</script>

<style lang="scss" scoped>
.info-dialog {
  position: absolute;
  left: 0;
  top: 0;
  background: #f6f6f6;
  width: 100%;
  z-index: 999999;
  bottom: 0;
  height: 100%;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    background: rgba(0, 0, 0, 0.1);
  }
  .podbean-logo,.close{
    position: fixed;
  }
  .info-main{
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .dialog-content {
    right: 0;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    display: block;
    padding: 0 35px 10px 15px;
    margin: 10px 0;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
      background: rgba(0, 0, 0, 0.1);
    }
  }
  .app-download {
    margin-top: 8px;
    .ios-img {
      margin-right: 3px;
    }
    img {
      width: 110px;
    }
  }
  p {
    margin-bottom: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .title{
    font-weight: 600;
  }
  .time{
    color: #838383;
  }
  .dialog-content > .description {
    text-align: initial !important;
  }
}
</style>

